export const decompose = (mat) => {
  var a = mat[0]
  var b = mat[1]
  var c = mat[2]
  var d = mat[3]
  var e = mat[4]
  var f = mat[5]

  var delta = a * d - b * c

  let result = {
    x: e,
    y: f,
    rotation: 0,
    scaleX: 0,
    scaleY: 0,
    skewX: 0,
    skewY: 0
  }

  // Apply the QR-like decomposition.
  if (a !== 0 || b !== 0) {
    var r = Math.sqrt(a * a + b * b)
    result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r)
    result.scaleX = r
    result.scaleY = delta / r
    result.skewX = Math.atan((a * c + b * d) / (r * r))
    result.scleY = 0
  } else if (c !== 0 || d !== 0) {
    var s = Math.sqrt(c * c + d * d)
    result.rotation =
      Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s))
    result.scaleX = delta / s
    result.scaleY = s
    result.skewX = 0
    result.skewY = Math.atan((a * c + b * d) / (s * s))
  } else {
    // a = b = c = d = 0
  }

  result.rotation *= 180 / Math.PI
  return result
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/decompose.js